import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  disabled: "",
  class: "btn btn-primary btn-lg"
}
const _hoisted_7 = {
  key: 1,
  class: "container"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from "@common/AdminNavigationV2.vue"
    import ValidationError from "@common/Components/ValidationError.vue"

    import type { WorkspaceReadModel } from "@Organizations/Workspaces/readmodels"

    import { useCurrentUserQueryV1 } from "@Organizations/Users/queries-vue-composables"
    import { useWorkspacesByOrganizationQueryV1 } from "@Organizations/Workspaces/queries-vue-composables"
    import { useCreateWorkspaceCommandV1 } from "@Organizations/Workspaces/commands-vue-composables"

    // ---------------- routing ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateWorkspacePage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid ?? 0))

    // ---------------- state ----------------

    const name = ref('')
    const description = ref('')
    const startupUrl = ref('')
    const workspaceCreated = ref(false)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Create a new workspace'
        runCurrentUserQueryV1()
    })

    // ---------------- queries ----------------

    const { runCurrentUserQueryV1 } = useCurrentUserQueryV1(false, false, true)

    const {
        modelWorkspacesByOrganizationQueryV1: workspacesModel,
        runWorkspacesByOrganizationQueryV1
    } = useWorkspacesByOrganizationQueryV1(tid)

    const workspaces = computed<WorkspaceReadModel[]>(() => workspacesModel.value?.Workspaces ?? [])

    const createdWorkspaceId = computed(() =>
        workspaces.value.find(w => w.Name === name.value)?.WorkspaceId
    )

    // ---------------- command ----------------

    const {
        invokeCreateWorkspaceCommandV1,
        invokingCreateWorkspaceCommandV1,
        succeedCreateWorkspaceCommandV1,
        validationErrorsCreateWorkspaceCommandV1
    } = useCreateWorkspaceCommandV1(
        () => '0',
        tid,
        name,
        description,
        startupUrl
    )

    const validationErrors = validationErrorsCreateWorkspaceCommandV1

    watch(succeedCreateWorkspaceCommandV1, succeed =>
    {
        if (succeed)
        {
            runWorkspacesByOrganizationQueryV1()
            workspaceCreated.value = true
        }
    })

    // ---------------- actions ----------------

    function handleCreateWorkspaceCommandV1()
    {
        if (invokingCreateWorkspaceCommandV1.value)
            return

        invokeCreateWorkspaceCommandV1()
    }

    function handleFinish()
    {
        name.value = ''
        description.value = ''
        startupUrl.value = ''
        workspaceCreated.value = false
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Create a new workspace</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!workspaceCreated.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
              class: "form-control",
              placeholder: "Name of workspace"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, name.value]
            ]),
            _createVNode(ValidationError, {
              context: "Name",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
              class: "form-control",
              placeholder: "Description of workspace"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, description.value]
            ]),
            _createVNode(ValidationError, {
              context: "Description",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Startup url:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startupUrl).value = $event)),
              class: "form-control",
              placeholder: "Startup url - only for advanced scenarios"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, startupUrl.value]
            ]),
            _createVNode(ValidationError, {
              context: "StartupUrl",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _withDirectives(_createElementVNode("button", {
            onClick: handleCreateWorkspaceCommandV1,
            class: "btn btn-primary btn-lg"
          }, " Create ", 512 /* NEED_PATCH */), [
            [_vShow, !_unref(invokingCreateWorkspaceCommandV1)]
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_6, " Creating... ", 512 /* NEED_PATCH */), [
            [_vShow, _unref(invokingCreateWorkspaceCommandV1)]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "fg-color-blue" }, "Workspace was created", -1 /* CACHED */)),
          (createdWorkspaceId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: `/#/admin/organizations/workspaces/manage/${createdWorkspaceId.value}`,
                  class: "btn btn-success text-white",
                  style: {"padding":"0.7em 2em"}
                }, " Manage workspace members ", 8 /* PROPS */, _hoisted_9),
                _cache[6] || (_cache[6] = _createElementVNode("h4", {
                  class: "fg-color-blue",
                  style: {"margin":"20px 0"}
                }, "or", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            onClick: handleFinish,
            class: "btn btn-secondary text-white",
            style: {"padding":"0.7em 2em"}
          }, " Add another workspace ")
        ]))
  ]))
}
}

})